import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Link, Modal } from '@honda-canada/design-system-react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { useTranslation } from 'react-i18next';

import gtmLearnMoreModal from '../../../core/gtm/gtmLearnMoreModal';
import { useSitecoreLayoutService } from '../../../apiHooks';

const StyledButton = styled(Link)(({ expanded }) =>
  css({
    visibility: expanded ? 'visible' : 'hidden',
    lineHeight: '22px',
  }),
);

const LearnMore = ({
  url,
  text,
  expanded,
  dataTestId,
  modalTitle,
  closeAriaLabel,
  buttonStyling = 'primary',
  buttonStyles = {},
  modalStyling = 'fullOverlay',
  trim,
  dealerName,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    response: layoutServiceResponse,
    placeholderName,
    isFetching,
    hasError,
  } = useSitecoreLayoutService(url.value);
  const { t } = useTranslation();

  if (!layoutServiceResponse || isFetching || hasError) return null;

  return (
    <Box display="flex" mb="xs" justifyContent="flex-end">
      <StyledButton
        as="button"
        styling={buttonStyling}
        expanded={expanded}
        onClick={() => {
          setIsModalOpen(true);
          gtmLearnMoreModal(dealerName, trim, 'open');
        }}
        data-testid={`${dataTestId}-label`}
        {...buttonStyles}
      >
        {text}
      </StyledButton>
      <Modal
        isOpen={isModalOpen}
        closeModal={() => {
          setIsModalOpen(false);
          gtmLearnMoreModal(dealerName, trim, 'close');
        }}
        closeAriaLabel={closeAriaLabel ?? t('Shared.Gallery.exitModalAria')}
        styling={modalStyling}
        allowClose
        data-testid={`${dataTestId}-content`}
      >
        {() => (
          <>
            {modalTitle}
            <Placeholder
              name={placeholderName}
              fields={{ reduceWidth: layoutServiceResponse?.sitecore?.route?.fields?.reduceWidth }}
              rendering={layoutServiceResponse?.sitecore?.route}
            />
          </>
        )}
      </Modal>
    </Box>
  );
};

export default LearnMore;
